<div *ngIf="show" class="modal-overlay">
  <div class="modal-window" [ngClass]="[size, position]">
    <div class="modal-header" *ngIf="showHeader">
      <h2>{{ title }}</h2>
      <button class="close-btn" (click)="onClose()">✕</button>
    </div>
    <ng-content *ngIf="!showHeader" select="[modal-header]"></ng-content>

    <div class="modal-body">
      <ng-content select="[modal-body]"></ng-content>
    </div>

    <div class="modal-footer" *ngIf="showFooter">
      <button class="btn cancel mr-1" (click)="onClose()">Cancelar</button>
      <button class="btn confirm" (click)="onConfirm()">Aceptar</button>
    </div>
    <ng-content  *ngIf="!showFooter" select="[modal-footer]"></ng-content>
  </div>
</div>